import { ISectionContainerProps } from "component-library";
import { TFunction } from "i18n";

import { AlertConfigBuilder } from "shared/utils/alert-config-builder";

export const getSectionContainerProps = (
  t: TFunction,
  handleCloseClick: () => void
): ISectionContainerProps => {
  return {
    header: t("performer:media.addNew.header"),
    variant: "shadowed",
    controls: [
      {
        text: t("common:button.label.close"),
        onClick: handleCloseClick,
      },
    ],
  };
};

export enum PopupTypes {
  CancelClose = "cancelPopup",
  Delete = "deletePopup",
}

export const getAlertMessage = (
  t: TFunction,
  popupType: PopupTypes,
  cancelContinuingAction: () => void,
  continueAction: () => void
) => {
  const popupPrefix =
    popupType === PopupTypes.CancelClose
      ? "performer:media.addNew.popup.cancel"
      : "performer:media.addNew.popup.delete";

  return new AlertConfigBuilder()
    .initBuildEntity()
    .setDefaultContent({
      closeButtonText: t(`${popupPrefix}.continueEditing`),
      description: t(`${popupPrefix}.description`),
      title: t("performer:media.addNew.popup.title"),
    })
    .setCloseButton({ type: "secondary", click: cancelContinuingAction })
    .addButton({
      type: "primary",
      click: continueAction,
      name: t(`${popupPrefix}.closePopupButton`),
    })
    .build();
};

export const getStoreLimitAlert = (t: TFunction, closeAction: () => void) =>
  new AlertConfigBuilder()
    .initBuildEntity()
    .setDefaultContent({
      title: t("performer:media.addNew.storeLimitAlert.title"),
      description: t("performer:media.addNew.storeLimitAlert.description"),
      closeButtonText: t("common:button.label.ok"),
    })
    .setCloseButton({ type: "primary", click: closeAction })
    .build();
